module.exports = __webpack_public_path__ + "img/ad.adad7b28b.svg";